import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@mui/icons-material/Close';

type Props = {
  onClick? : (e : any) => void;
}

export default function ServerlessDeleteButton({onClick} : Props) {
  return (
    <IconButton aria-label="delete" onClick={onClick}>
      <CloseIcon />
    </IconButton>
  )
}